export default {
	trigger: 'View damage location',
};
